import { render, staticRenderFns } from "./Produccion.vue?vue&type=template&id=34b653ca&scoped=true"
import script from "./Produccion.vue?vue&type=script&lang=js"
export * from "./Produccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b653ca",
  null
  
)

export default component.exports